/**
 * PDF Viewer Editor
 * Handles configuration for pdf-viewer display controls
 */

import React from 'react';
import type { PropertyEditor, PropertyEditorProps } from '../../../registry/PropertyEditor.types';

/**
 * Render function for pdf-viewer control
 */
function renderPdfViewerEditor(props: PropertyEditorProps) {
  const { control, onConfigChange } = props;

  return (
    <div className="af-properties-tab__section">
      <h4 className="af-properties-tab__subsection-title">Control Configuration</h4>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          PDF URL
          <input
            type="text"
            value={(control.config?.src as string) || ''}
            onChange={(e) => onConfigChange('src', e.target.value || undefined)}
            className="af-properties-tab__input"
            placeholder="https://.../document.pdf"
          />
        </label>
      </div>
      <div className="af-properties-tab__group">
        <label className="af-properties-tab__label">
          Height (px)
          <input
            type="number"
            min="100"
            value={(control.config?.height as number) ?? 600}
            onChange={(e) => onConfigChange('height', e.target.value ? parseInt(e.target.value) : 600)}
            className="af-properties-tab__input"
            placeholder="600"
          />
        </label>
      </div>
    </div>
  );
}

/**
 * PdfViewerEditor - Handles pdf-viewer control configuration
 */
export const PdfViewerEditor: PropertyEditor = {
  type: 'pdf-viewer',
  label: 'PDF Viewer',
  description: 'Configure PDF URL and height',
  render: renderPdfViewerEditor,
};
